// src/main.tsx

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext"; // Existing AuthProvider
import { AudioProvider } from "./contexts/AudioContext"; // <-- IMPORT THE NEW PROVIDER



const queryClient = new QueryClient();


ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AudioProvider>
          {" "}
          {/* <-- WRAP YOUR APP WITH THE AUDIO PROVIDER */}
          <App />
        </AudioProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
